import type {
  ChecklistColumnNumber,
  ChecklistItem,
  ClientSignsSymptomsOption,
  EvidenceBasedInterventionsOption,
} from './types';
import type {
  IEvidenceBasedInterventionsUsed,
  ISignsAndSymptomsObserved,
} from '../../../../../utils/types';
import type { TFunction } from 'i18next';

export function getChecklistItemsForColumn(
  items: ChecklistItem[],
  columnNumber: ChecklistColumnNumber,
): ChecklistItem[] {
  return items.filter((item) => item.columnNumber === columnNumber);
}

export function buildCheckboxTestId(label: string): string {
  return `checkbox${label.split(' ').join('')}`;
}

export function getClientSignsSymptomsItems(
  options: ClientSignsSymptomsOption[],
  data: ISignsAndSymptomsObserved,
  t: TFunction<'sessionNotes'>,
): ChecklistItem[] {
  return options.map((option) => {
    if (
      option.id === 'restricted_repetitive_behaviors' &&
      typeof data.restricted_receptive_behaviors === 'boolean'
    ) {
      return {
        id: 'restricted_receptive_behaviors',
        label: t('symptomsObserved.fields.restrictedReceptiveBehaviors'),
        checked: data.restricted_receptive_behaviors,
        description: option.description,
        columnNumber: option.columnNumber,
      };
    }

    return {
      id: option.id,
      label: option.label,
      checked: Boolean(data[option.id]),
      description: option.description,
      columnNumber: option.columnNumber,
    };
  });
}

export function getEvidenceBasedInterventionItems(
  options: EvidenceBasedInterventionsOption[],
  data: IEvidenceBasedInterventionsUsed,
): ChecklistItem[] {
  return options
    .filter(
      (option) =>
        option.id !== 'functional_behavior_assessment' ||
        data.functional_behavior_assessment !== null,
    )
    .map((option) => ({
      id: option.id,
      label: option.label,
      checked: Boolean(data[option.id]),
      description: option.description,
      columnNumber: option.columnNumber,
    }));
}
